import { CommonModule } from '@angular/common';
import { NgModule, Provider, Type } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FingerprintAIO } from '@ionic-native/fingerprint-aio/ngx';
import { Network } from '@ionic-native/network/ngx';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { IonicModule } from '@ionic/angular';
import { ROUTE_COMPONENTS } from '../constants';
import { SitesModule } from '../modules/sites/sites.module';
import { RouteComponentRegistries } from './ComponentRegistry';
import { DynamicPageModule } from './dynamicPage';
import { PipeModule } from '../pipes';

const modules: Type<any>[] = [
	PipeModule,
	IonicModule,
	FormsModule,
	CommonModule
];
const osappModules: Type<any>[] = [
	DynamicPageModule,
	SitesModule
];
const providers: Provider[] = [
	SocialSharing,
	Network,
	FingerprintAIO,
	{ provide: ROUTE_COMPONENTS, useValue: RouteComponentRegistries }
];

/** Ce module regroupe tous les composants généraux de la bibliothèque. */
@NgModule({
	imports: [modules, ...osappModules],
	exports: [...osappModules],
	providers: providers
})
export class ComponentsModule { }